import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BackgroundRepeat extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Repeat",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Yes",
          value: "repeat",
        },
        {
          label: "No",
          value: "no-repeat",
        },
      ],
    },
  };

  static defaultValue = "no-repeat";
}
